// src/components/TechPartners.js

import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './TechPartners.css';

// Import logos from src/tech_logos
import awsLogo from '../tech_logos/icons8-amazon-web-services-100.svg';
import gcpLogo from '../tech_logos/icons8-google-cloud-platform-100.svg';
import pythonLogo from '../tech_logos/icons8-python-100.svg';
import dockerLogo from '../tech_logos/icons8-docker-100.svg';
import kubernetesLogo from '../tech_logos/icons8-kubernetes-100.svg';
import reactLogo from '../tech_logos/icons8-react-native-100.svg';
import typescriptLogo from '../tech_logos/icons8-typescript-100.svg';
import githubLogo from '../tech_logos/icons8-github-100.svg';
import gitlabLogo from '../tech_logos/icons8-gitlab-100.svg';
import microsoftLogo from '../tech_logos/icons8-microsoft-100.svg';
import confluenceLogo from '../tech_logos/icons8-confluence-100.svg';
import bitbucketLogo from '../tech_logos/icons8-bitbucket-100.svg';
import angularLogo from '../tech_logos/icons8-angularjs-100.svg';
import cppLogo from '../tech_logos/icons8-c++-100.svg';
import swiftLogo from '../tech_logos/icons8-swift-100.svg';
import androidLogo from '../tech_logos/icons8-android-os-100.svg';
import aiLogo from '../tech_logos/icons8-ai-100.svg';

// Row 1 - Cloud, AI, Data platforms
const techPartnersRow1 = [
  { name: 'AWS', logo: awsLogo },
  { name: 'Google Cloud', logo: gcpLogo },
  { name: 'Microsoft Azure', logo: microsoftLogo },
  { name: 'Python', logo: pythonLogo },
  { name: 'Docker', logo: dockerLogo },
  { name: 'Kubernetes', logo: kubernetesLogo },
  { name: 'AI/ML', logo: aiLogo },
  { name: 'GitHub', logo: githubLogo },
  { name: 'GitLab', logo: gitlabLogo },
];

// Row 2 - Development tools & frameworks
const techPartnersRow2 = [
  { name: 'React', logo: reactLogo },
  { name: 'TypeScript', logo: typescriptLogo },
  { name: 'Angular', logo: angularLogo },
  { name: 'C++', logo: cppLogo },
  { name: 'Swift', logo: swiftLogo },
  { name: 'Android', logo: androidLogo },
  { name: 'Confluence', logo: confluenceLogo },
  { name: 'Bitbucket', logo: bitbucketLogo },
];

// Duplicate items for seamless infinite scroll
const duplicateForScroll = (items) => [...items, ...items, ...items, ...items];

// Logo Card Component with circular design
const LogoCard = ({ partner }) => {
  const [imageError, setImageError] = useState(false);

  return (
    <div className="tech-partners__logo-card">
      {!imageError ? (
        <img
          src={partner.logo}
          alt={partner.name}
          className="tech-partners__logo-img"
          onError={() => setImageError(true)}
        />
      ) : (
        <span className="tech-partners__logo-text tech-partners__logo-text--visible">
          {partner.name}
        </span>
      )}
    </div>
  );
};

const TechPartners = () => {
  return (
    <section className="tech-partners" id="partners">
      {/* Background */}
      <div className="tech-partners__bg">
        <div className="tech-partners__gradient" />
      </div>

      {/* Content */}
      <div className="tech-partners__content">
        <motion.div
          className="tech-partners__header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="tech-partners__badge">
            <span className="tech-partners__badge-icon">⚡</span>
            Technology Stack
          </span>

          <h2 className="tech-partners__title">
            Powered by
            <span className="tech-partners__title-gradient"> Industry-Leading Platforms</span>
          </h2>

          <p className="tech-partners__subtitle">
            We leverage best-in-class cloud platforms, data tools, and AI frameworks to deliver enterprise-grade solutions
          </p>
        </motion.div>

        {/* Scrolling Logos */}
        <div className="tech-partners__carousel">
          {/* Row 1 - Scrolls Left */}
          <div className="tech-partners__track tech-partners__track--left">
            <div className="tech-partners__track-inner">
              {duplicateForScroll(techPartnersRow1).map((partner, index) => (
                <LogoCard key={`row1-${index}`} partner={partner} />
              ))}
            </div>
          </div>

          {/* Row 2 - Scrolls Right */}
          <div className="tech-partners__track tech-partners__track--right">
            <div className="tech-partners__track-inner">
              {duplicateForScroll(techPartnersRow2).map((partner, index) => (
                <LogoCard key={`row2-${index}`} partner={partner} />
              ))}
            </div>
          </div>

          {/* Fade overlays */}
          <div className="tech-partners__fade tech-partners__fade--left" />
          <div className="tech-partners__fade tech-partners__fade--right" />
        </div>
      </div>
    </section>
  );
};

export default TechPartners;
